import { Title } from '~/modules/storefront/components/common/Title.tsx';

export function TokenExpiredMessage() {
  return <Title>Your link has expired. Please request a new one</Title>;
}
